export const projectsProjectRecordPolicyV1Capability = 'projects.record-policy.v1';
export const projectsProjectRecordPolicyCapability = 'projects.record-policy.v2';
export const projectsProjectManageAllPermission = 'projects.projects.manage-all';
export const projectsProjectRecordPolicyDatabaseFunction = 'projects.current_membership_can_write_project';
export const projectsProjectReadPolicyDatabaseFunction = 'projects.current_membership_can_read_project';
/**
 * Stable Projects record boundary:
 *
 * - `projects.projects.read` is necessary but does not expose an unassigned Project.
 * - an active Project assignment or `projects.projects.manage-all` authorizes read access.
 * - mutation-specific permission is still required for each action.
 * - assignment to the Project or `projects.projects.manage-all` authorizes the
 *   record-level mutation.
 * - the public Project contracts expose the resolved decision as `canWrite`.
 * - retained/offline decisions must be revalidated on the server before use.
 */
export const projectsProjectRecordPolicyVersion = 2;
//# sourceMappingURL=projects-project-record-policy.contract.js.map